import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { EInvoiceSubmission } from '../models/e-invoice-submission.model';

@Injectable({
  providedIn: 'root',
})
export class EInvoiceSubmissionsService extends BaseApiService<EInvoiceSubmission> {
  override model: Type<EInvoiceSubmission> = EInvoiceSubmission;

  override get endpoint(): string {
    return '/invoicing/e-invoicing/submissions';
  }
}
